import { Id } from '@nextforce/api'

const keys = {
  all: ['file_folder_repository'],
  chatGroup: (conversationId: Id) => [...keys.all, conversationId, 'folders'],
  chatGroupFolder: (conversationId: Id, folderId?: Id) => [
    ...keys.all,
    conversationId,
    'folders',
    folderId,
  ],
  sharedChatGroupFolder: (conversationId: Id, folderId?: Id) => [
    ...keys.all,
    conversationId,
    'shared',
    'folders',
    folderId,
  ],
  folder: (folderId?: Id) => [...keys.all, 'folders', folderId],
  file: (fileId?: Id) => [...keys.all, 'files', fileId],
  fileAcknowledgements: (fileId?: Id) => [
    ...keys.all,
    'files',
    fileId,
    'acknowledgements',
  ],
  fileAcknowledgementUserIds: (fileId?: Id) => [
    ...keys.all,
    'files',
    fileId,
    'acknowledgement_user_ids',
  ],
  recent: (conversationId: Id, limit?: number) => [
    ...keys.all,
    conversationId,
    'recent',
    limit,
  ],
  latest: () => [...keys.all, 'latest'],
  media: (conversationId: Id) => [...keys.all, conversationId, 'media'],
  allFileFolders: (conversationId: Id) => [
    ...keys.all,
    conversationId,
    'allFileFolders',
  ],
  content: (fileId?: Id, versionNumber?: number) => [
    ...keys.all,
    'content',
    fileId,
    versionNumber,
  ],
  filesWithAcknowledgementList: (conversationId: Id) => [
    ...keys.all,
    conversationId,
    'filesWithAcknowledgementList',
  ],
}

export default keys
